module.exports = __webpack_public_path__ + "static/img/8.c44cd55b.png";